module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"EzyMedical","short_name":"EzyMedical","description":"Get covered for international and domestic travel delays, loss of baggage, medical emergencies and other travel inconveniences.","lang":"en","start_url":"/","background_color":"#FFF","theme_color":"#FFBF00","display":"standalone","icon":"src/assets/images/Etiqa_Favicon.png","icon_options":{"purpose":"maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c2320f08283c6cff484234bd391d2282"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
